// FreeAccountPageData.ts

const defaultPageData = {
  meta: {
    canonical: 'https://www.which.co.uk/free-account',
    title: 'Create a Free Which? Account',
    fbAppId: '320949621749168',
    desc: 'Create a Free Which? Account | Try Trusted Reviews Fortnightly',
  },
  text: {
    heroImage: 'https://media.which.gpp.io/prod/images/original/f071a0fbf855-free-account.png',
    heroImageAlt: 'Gift card',
    heroTitle: 'Get a free review every fortnight',
    heroDescription:
      'Sign up for a free account to get expert recommendations for top products without paying a penny.',
    heroSampleLink: 'See a sample review',
    heroSignupButton: 'Sign up',
    howItWorksTitle: 'How it works',
    bulletPoints: [
      'Sign up, no payment required',
      'Our experts will send you a head-to-head review of two products straight to your inbox every fortnight',
      'Unsubscribe, or upgrade to paid membership, anytime',
      'The Which? free account is still new, and we might change the benefits you receive as we listen to your feedback',
    ],
    aboutTitle: 'Always impartial, never for profit',
    aboutParagraphs: [
      'As the UK’s consumer champion, we’re proudly independent — no ads, no bias.',
      'Everything we do, from our rigorous product testing to campaigning against consumer harm, is funded by our members and reinvested into our mission to make life simpler, safer and fairer for everyone.',
    ],
    sampleLink: '/free-account-exclusive',
    signupLink: '/registration?freeAccount=true',
  },
}
export const freeAccountPageContent = {
  anonymous: defaultPageData,
  member: {
    ...defaultPageData,
    text: {
      ...defaultPageData.text,
      heroTitle: 'Activate your free Which? account',
      heroDescription: `To complete sign up, please confirm your preferences below.`,
      signupLink: `${process.env.PAYWALL_URL}update-free-account`,
    },
  },
  payingMember: {
    ...defaultPageData,
    text: {
      ...defaultPageData.text,
      heroImage: 'https://media.which.gpp.io/prod/images/original/f071a0fbf855-free-account.png',
      heroImageAlt: 'Gift card',
      heroTitle: "You're already a member",
      heroDescription:
        'As a subscriber to Which?, you already get all of the benefits of your membership.',
      heroSignupButton: 'Explore homepage',
      signupLink: '/',
    },
  },
  freeMember: {
    ...defaultPageData,
    text: {
      ...defaultPageData.text,
      heroTitle: 'You already have a free account',
      heroDescription: 'Check out your latest free fortnightly head-to-head review.',
      heroSignupButton: 'See review',
      signupLink: '/free-account-exclusive',
    },
  },
} as const
